// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common-title {\n  font: 700 60px/127% \"proxima nova\", sans-serif;\n  color: inherit;\n  margin: 0 0 90px 0; }\n  @media only screen and (max-width: 992px) {\n    .common-title {\n      margin: 0 0 40px 0;\n      font-size: 40px; } }\n  @media only screen and (max-width: 750px) {\n    .common-title {\n      font-size: 24px;\n      margin: 0 0 20px 0; } }\n", ""]);
// Exports
module.exports = exports;
